import styles from './FAQ.module.scss'

type Props = {
  contents: {
    question: string
    answer: string
  }[]
}

export const FAQ: React.FC<Props> = ({ contents }) => {
  return (
    <div className={styles.faq_container}>
      <div className={styles.main_container}>
        <p className={styles.title}>よくあるご質問</p>
        <div className={styles.faq_list_container}>
          {contents.map((content) => (
            <div className={styles.faq_item} key={content.question}>
              <div className={styles.faq_item_container}>
                <div className={styles.faq_circle_red}>
                  <p className={styles.faq_circle_text}>Q</p>
                </div>
                <p className={styles.faq_question}>{content.question}</p>
              </div>
              <div className={styles.faq_item_container}>
                <div className={styles.faq_circle}>
                  <p className={styles.faq_circle_text_answer}>A</p>
                </div>
                <p className={styles.faq_answer}>{content.answer}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}
